export const START_OF_DAY = '00:00';
export const END_OF_DAY = '23:59';

export const DAYS_OF_WEEK = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
export const STATUS = ['open', 'closed'] as const;

export const DOSHII_MENU_NAME_INDEX = 2;
export const IDENTIFIER_LOADING_PREFIX = 'loading-';

export const DEFAULT_TIMEZONE = 'Australia/Sydney';
